export default __webpack_public_path__ + "static/media/one-mini.dba49e3d.glb";